// Callout.tsx — Technical documentation-style callout, rendered on Bootstrap's
// semantic Alert. Each recipe variant maps onto the semantic variant that
// carries the same meaning (DESIGN.md C-BTN-1 / Appendix A "Alerts"), so the
// colors come from Bootswatch rather than a bespoke palette.
import React from 'react'
import Alert from 'react-bootstrap/Alert'
import { BsInfoCircle, BsExclamationTriangle, BsLightbulb, BsFire } from 'react-icons/bs'

export type CalloutVariant = 'note' | 'warning' | 'tip' | 'caution'

interface CalloutProps {
    variant: CalloutVariant
    title?: string
    children: React.ReactNode
}

const variantConfig: Record<
    CalloutVariant,
    { icon: React.ReactNode; label: string; bsVariant: string }
> = {
    note: { icon: <BsInfoCircle />, label: 'Note', bsVariant: 'info' },
    warning: { icon: <BsExclamationTriangle />, label: 'Warning', bsVariant: 'warning' },
    tip: { icon: <BsLightbulb />, label: 'Tip', bsVariant: 'success' },
    caution: { icon: <BsFire />, label: 'Caution', bsVariant: 'danger' },
}

const Callout: React.FC<CalloutProps> = ({ variant, title, children }) => {
    const config = variantConfig[variant]
    return (
        <Alert variant={config.bsVariant} className="mb-3">
            <Alert.Heading className="fs-6 d-flex align-items-center gap-2 mb-2">
                {config.icon} {title || config.label}
            </Alert.Heading>
            <div className="mb-0">{children}</div>
        </Alert>
    )
}

export default Callout
